/**
 * Class to build and render forms
 *
 * @author: Kete Martins
 * Date: 03/12/13
 * Time: 10:58
 */


Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.Map = Greenmile.Toolbar.Map || {};
Greenmile.Toolbar.Map.Components = Greenmile.Toolbar.Map.Components || {};

Greenmile.Toolbar.Map.Components = function (selector) {
    this.render = function (template, action) {

        var query = selector;
        if (template.selector === "#coords_template") {
            query += " ul.dropdownMeasurement li ul";
        } else {
            query += " .mapToolBar ." + template.position;
        }

        const selectorId = selector.replace(/[^a-zA-Z0-9]/g, "");

        var layout = Greenmile.Toolbar.Map.Layouts[template.selector](selectorId);
        var contentHtml = document.querySelector(query);
        var generator = new Monet.UI.LayoutGenerator(layout);

        contentHtml.appendChild(generator.render());
        
        if (action?.addListeners) action.addListeners()

    };

};
